import Button from "component/Button/Button";
import React, { useRef, useState } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

import neo1Demo from "../../assets/video/neo1Demo.mp4";

import playButton from "../../assets/images/home/playButton.svg";
import on from "../../assets/images/home/On.svg";
import off from "../../assets/images/home/Off.svg";

import collaborate from "../../assets/images/hearFromBest/collaborate.png";
import collaborateTab from "../../assets/images/hearFromBest/collaborateTab.png";
import collaborateMobile from "../../assets/images/hearFromBest/collaborateMobile.png";

import useScreenMobile from "hooks/useScreenMobile";

import "./hearFromBest.scss";

const HearFromTheBest = () => {
  const videoRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(true);
  const [mute, setMute] = useState(false);
  const [poster, setPoster] = useState(false);

  const isTab = useScreenMobile({ size: 768 });
  const isMobile = useScreenMobile({ size: 568 });

  const imagePlaceHolder = isMobile
    ? collaborateMobile
    : isTab
      ? collaborateTab
      : collaborate;

  const trackEvent = (event) => {
    console.log(`Video event: ${event}`);
  };

  const togglePlayPause = () => {
    setPoster(true);

    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        trackEvent("pause");
      } else {
        videoRef.current.muted = mute;
        videoRef.current.play();
        trackEvent("play");
      }

      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
    videoRef.current.poster = imagePlaceHolder;
    setShowPlayButton(true);
    setPoster(false);
    trackEvent("ended");
  };

  return (
    <section className="hearFromBest">
      <div className="container hearFromBestContainer">
        <div className="common-heading">
          <h1 className="topToBottom">Become a NeoSapien</h1>
        </div>

        <div className="introducing " onClick={togglePlayPause}>
          {!poster && (
            <div className="posterBox">
              <img
                src={imagePlaceHolder}
                alt="imagePlaceHolder"
                className="poster"
              />
            </div>
          )}

          <video
            style={{ objectFit: isMobile && "cover" }}
            ref={videoRef}
            className="recipe"
            width="100%"
            playsInline
            preload="auto"
            muted
            onEnded={handleVideoEnd}
          >
            <source src={neo1Demo} type="video/mp4" />
          </video>

          {!isPlaying && showPlayButton && (
            <div className="playPauseButton" onClick={togglePlayPause}>
              <img src={playButton} alt="Play button" />
            </div>
          )}

          {
            <div
              className="onOffBox"
              onClick={(e) => {
                e.stopPropagation();

                if (!mute) {
                  videoRef.current.muted = true;

                  setMute(true);
                } else {
                  videoRef.current.muted = false;

                  setMute(false);
                }
              }}
            >
              <img src={mute ? off : on} alt="speaker" />
            </div>
          }
        </div>

        <div style={{ marginTop: "4rem" }} />

        <Button
          title="Order Now"
          onClick={() => {
            logEvent(analytics, "order_now_overlays");
            window.location.href = "https://shop.neosapien.xyz/";
          }}
          fontsize={isMobile ? "16px" : "20px"}
          padding={isMobile ? "16px 24px " : "15px 30px"}
        />
      </div>
    </section>
  );
};
export default HearFromTheBest;
